let BASE_URL = process.env.REACT_APP_API_URL;

if (!BASE_URL) {
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    BASE_URL = "http://localhost:8000/";
  } else {
    BASE_URL = "https://mail-sender-api-737008688123.asia-south1.run.app/";
  }
}

export { BASE_URL };

